import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FilterContext } from "../../context/FilterContext";

const PathShow = ({ name, category, brand, categoryId, brandId }) => {
  const filterData = useContext(FilterContext);

  const { setfilter_category } = filterData;

  return (
    <div className="flex gap-3">
      <Link  to={`/${categoryId}`}>
        {category}
      </Link>
      {">"}
      <Link to={`/${categoryId}/${brandId}`}>{brand}</Link>
      {name && (
        <>
          {">"}
          <span>{name}</span>
        </>
      )}
    </div>
  );
};

export default PathShow;
